import ListViewController from './list-view.controller';
import { ListViewProps } from './list-view.model';

const ListView = (props: ListViewProps) => {
  return <ListViewController {...props} />;
};

export default ListView;
